var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33073 7.9987H6.9974L7.66406 5.33203H5.33073V3.9987C5.33073 3.31203 5.33073 2.66536 6.66406 2.66536H7.66406V0.425365C7.44673 0.396698 6.62606 0.332031 5.7594 0.332031C3.9494 0.332031 2.66406 1.4367 2.66406 3.46536V5.33203H0.664062V7.9987H2.66406V13.6654H5.33073V7.9987Z",
    fill: "#00465C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.b2eac01612dd7d455b03e0579636e5f9.svg";
export { ForwardRef as ReactComponent };